module.exports = __webpack_public_path__ + "media/images/icons/logo-BI-0c37ba8e85a5390f212b710267019507.svg";